import { render } from "./ListeChambre.vue?vue&type=template&id=8fa264ee"
import script from "./ListeChambre.vue?vue&type=script&lang=js"
export * from "./ListeChambre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__